import React, { createContext, useContext, useState, useEffect } from "react";
import { loaderService } from "./LoaderService";

const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    loaderService.register(setIsLoading);
  }, []);

  return (
    <LoaderContext.Provider value={isLoading}>
      {children}
    </LoaderContext.Provider>
  );
};

export const useLoader = () => useContext(LoaderContext);
